import React from "react";
import Alert from "../Alert/Alert"; 

const NOPheaders = ({ id, status, convictions, nops, insolvency, ...props }) => {

  const noticeOrdersTab = [
    //COMPLIANCE Banners
    "Immediate Compliance Order Issued",
    "Notice of Proposal to Make a Compliance Order Issued - Under Appeal",
    "Compliance Order Issued",
    "NOTICE OF PROPOSAL TO MAKE A COMPLIANCE ORDER ISSUED",
    "Notice of Proposal to Make a Compliance Order",
    "NOP to Make a Compliance Order", //NEW
    //CONDITIONS Banners
    "Proposed Conditions on Licence",
    "Proposed Conditions on Licence - Under Appeal",
    "Conditions on Licence",
    "NOP Conditions", //NEW
    "NOP Conditions-Under Appeal", //NEW
    "CONDITIONS ON LICENSE​", //NEW
    //REFUSAL Banners
    "Proposed Licence Refusal",
    "Proposed Licence Refusal – Under Appeal",
    "Licence Refused",
    "NOP Refuse", //NEW
    "NOP Refuse - Under Appeal", //NEW
    //REVOCATION Banners
    "Proposed Licence Revocation",
    "Proposed Licence Revocation – Under Appeal",
    "Licence Revoked",
    "NOP Revoke", //NEW
    "NOP Revoke - Under Appeal", //NEW
    //Advertising Banners
    "Advertising Order – Under Appeal",
    "Advertising Order Issued",
    //Suspension Banners
    "Proposed Licence Suspension",
    "Suspended",
    //Admin Penalty Banners
    "Administrative Penalty - Under Appeal",
    "Administrative Penalty",
    //Miscellaneous Banners
    "NOP Suspension",
    "NOP Not to Renew",
    "NOP Revoke",
    "NOP Revoke - Under Appeal",
    "Freeze Order Issued",
    "Freeze Order Issued - Under Appeal",
  ];
  // console.log(insolvency);
  const discplineTab = [
    "Charged and/or Convicted", "Disciplinary Action issued",
    "ALLEGATIONS"
  ];

  return (
    <>
      {insolvency && insolvency.length > 0 && insolvency[0].OBD_BANNER_POSTED === "Yes" && (
        <Alert type="warning" header="Licensee is subject to Insolvency Proceedings">
          For more information, see the Notices and Orders tab.
        </Alert>
      )}
      {nops && nops
        .filter((nop) => nop.PROFILE_BANNER !== null && nop.SHOW_ON_OBD_FLAG === "true" && (nop.VB_IN_COMPLIANCE === "false" || nop.VB_IN_COMPLIANCE == null))
        .map((nop, index) => (
          <Alert key={index} type="warning" header={nop.PROFILE_BANNER}>
            {noticeOrdersTab.map(tab => tab.toLowerCase()).includes(nop.PROFILE_BANNER.toLowerCase()) ? (
              "For more information, see the Notices and Orders tab."
            ) : discplineTab.map(tab => tab.toLowerCase()).includes(nop.PROFILE_BANNER.toLowerCase()) ? (
              "For more information, see the Disciplinary Activities tab."
            ) : (
              "No additional information available."
            )}
          </Alert>
        ))}
    </>
  );
};

export default NOPheaders;
